export default __webpack_public_path__ + "static/media/cp_geo_lt.04cf258e.svg";